<template>
  <div class="page" :class="{ 'page__has-bar': !readonly }">
    <div class="page__bd">
      <DownloadButton :caller="caller" :id="form.main.id || bizData.bizId"/>
      <div class="form-preview weui-form-preview">
        <div class="weui-form-preview__hd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">单据编号</label>
            <em class="weui-form-preview__value">{{ form.main.pu_code }}</em>
          </div>
        </div>
      <div class="weui-form-preview__bd">
        <custom-layout :view-config="customViewConfig">
          <div class="weui-form-preview__item" slot="pu_vendname">
            <label class="weui-form-preview__label">{{customLabel.pu_vendname || "供应商"}}</label>
            <em class="weui-form-preview__value">{{
              form.main.pu_vendname
            }}</em>
          </div>
          <div class="weui-form-preview__item" slot="pu_contact">
            <label class="weui-form-preview__label">{{customLabel.pu_contact || "联系人"}}</label>
            <span class="weui-form-preview__value weui-form-preview__value-icon"
              >{{ form.main.pu_contact }} {{ form.main.pu_tel }}
              <call-mobile :mobile="form.main.pu_tel"></call-mobile>
            </span>
          </div>
          <div class="weui-form-preview__item" slot="pu_shipaddresscode">
            <label class="weui-form-preview__label">{{customLabel.pu_shipaddresscode || "交货地址"}}</label>
            <span class="weui-form-preview__value">{{
              form.main.pu_shipaddresscode
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="pu_payments">
            <label class="weui-form-preview__label">{{customLabel.pu_payments || "付款方式"}}</label>
            <span class="weui-form-preview__value">
              {{ form.main.pu_payments }}
              <span v-if="form.main.pu_currency">{{
                form.main.pu_currency
              }}</span>
              <span v-if="form.main.pu_rate && form.main.pu_rate != 1"
                >/ {{ form.main.pu_rate }}</span
              >
            </span>
          </div>
          <div class="weui-form-preview__item" slot="pu_taxrate">
            <label class="weui-form-preview__label">{{customLabel.pu_taxrate || "税率"}}</label>
            <span class="weui-form-preview__value">
              {{ form.main.pu_taxrate }}
            </span>
          </div>
          <div class="weui-form-preview__item" slot="pu_date">
            <label class="weui-form-preview__label">{{customLabel.pu_date || "采购日期"}}</label>
            <span class="weui-form-preview__value" v-format="'yyyy-MM-dd'">{{
              form.main.pu_date
            }}</span>
          </div>
          <custom-field :readOnly="true" :label="customLabel.pu_text1 || '自定义字段1'"
          v-model="form.main.pu_text1" slot="pu_text1" hidden="true" />
          <custom-field :readOnly="true" :label="customLabel.pu_text2 || '自定义字段2'"
          v-model="form.main.pu_text2" slot="pu_text2" hidden="true" />
          <custom-field :readOnly="true" :label="customLabel.pu_text3 || '自定义字段3'"
          v-model="form.main.pu_text3" slot="pu_text3" hidden="true" />
          <custom-field :readOnly="true" :label="customLabel.pu_text4 || '自定义字段4'"
          v-model="form.main.pu_text4" slot="pu_text4" hidden="true" />
          <custom-field :readOnly="true" :label="customLabel.pu_text5 || '自定义字段5'"
          v-model="form.main.pu_text5" slot="pu_text5" hidden="true" />
        </custom-layout>
         <div class="weui-form-preview__item" slot="pu_buyername" v-if="form.main.pu_buyername">
            <label class="weui-form-preview__label">采购员</label>
            <span class="weui-form-preview__value weui-form-preview__value-icon"
              >{{ form.main.pu_buyername }}
              <call-mobile :em-id="form.main.pu_buyerid"></call-mobile>
            </span>
          </div>
          <div class="weui-form-preview__item" slot="pu_dpname" v-if="form.main.pu_dpname">
            <label class="weui-form-preview__label">部门</label>
            <span class="weui-form-preview__value"
              >{{ form.main.pu_dpname }}
            </span>
          </div>
      </div>
      </div>

      <collapse class="form-preview weui-form-preview" :title="'明细（'+form.items.length+'条）'">
        <div
          class="weui-form-preview__bd form-detail-preview"
          v-for="item in form.items"
          :key="item.id"
        >
          <div class="form-detail-preview_num">{{ item.pd_detno }}</div>
          <custom-layout :view-config="customViewConfig" position="detail1">
            <div class="weui-form-preview__item" slot="pr_detail">
              <label class="weui-form-preview__label">{{customLabel.pr_detail || "产品名称"}}</label>
              <span class="weui-form-preview__value">{{
                item.productDTO.pr_detail
              }}</span>
            </div>
            <div class="weui-form-preview__item" slot="pd_prodcode" v-if="item.pd_prodcode">
              <label class="weui-form-preview__label">{{customLabel.pd_prodcode || "产品编号"}}</label>
              <span class="weui-form-preview__value">{{
                item.pd_prodcode
              }}</span>
            </div>
            <div class="weui-form-preview__item" slot="pr_orispeccode" v-if="item.productDTO && item.productDTO.pr_orispeccode">
              <label class="weui-form-preview__label">{{customLabel.pr_orispeccode || "型号"}}</label>
              <span class="weui-form-preview__value">{{
                item.productDTO.pr_orispeccode
              }}</span>
            </div>
            <div class="weui-form-preview__item" slot="pr_spec" v-if="item.productDTO && item.productDTO.pr_spec">
              <label class="weui-form-preview__label">{{customLabel.pr_spec || "规格"}}</label>
              <span class="weui-form-preview__value">{{
                item.productDTO.pr_spec
              }}</span>
            </div>
            <div class="weui-form-preview__item" slot="pr_brand" v-if="item.productDTO && item.productDTO.pr_brand">
              <label class="weui-form-preview__label">{{customLabel.pr_brand || "厂家/品牌"}}</label>
              <span class="weui-form-preview__value">{{
                item.productDTO.pr_brand
              }}</span>
            </div>
            <div class="weui-form-preview__item" slot="pd_qty">
              <label class="weui-form-preview__label">{{customLabel.pd_qty || "数量"}}</label>
              <span class="weui-form-preview__value"
                >{{ item.pd_qty }} {{ item.productDTO.pr_unit }}</span
              >
            </div>
            <div class="weui-form-preview__item" slot="pd_qty_extra" v-if="item.productDTO && item.productDTO.pr_unit_extra">
              <label class="weui-form-preview__label">{{
                customLabel.pd_qty_extra || "辅助数量"
              }}</label>
              <span class="weui-form-preview__value"
                >{{ item.pd_qty_extra }} {{ item.productDTO.pr_unit_extra }}</span
              >
            </div>
            <div class="weui-form-preview__item" slot="pd_taxprice">
              <label class="weui-form-preview__label">{{customLabel.pd_taxprice || "不含税单价(元)"}}</label>
              <span class="weui-form-preview__value">{{
                numberFormat(item.pd_taxprice,'#,##0.####')
              }}</span>
            </div>
            <div class="weui-form-preview__item" slot="pd_price">
              <label class="weui-form-preview__label">{{customLabel.pd_price || "含税单价(元)"}}</label>
              <span
                class="weui-form-preview__value weui-form-preview__value-icon"
              >
                {{ item.pd_price }}
                <router-link
                  class="iconfont icon-history"
                  :to="{
                    path: '/purchase/order_report',
                    query: { hq_keyword: item.pd_prodcode },
                  }"
                ></router-link>
              </span>
            </div>
            <div class="weui-form-preview__item" slot="pd_price_extra" v-if="item.productDTO && item.productDTO.pr_unit_extra">
              <label class="weui-form-preview__label">{{
                customLabel.pd_price_extra || "辅助单价(元)"
              }}</label>
              <span class="weui-form-preview__value"
                >{{ item.pd_price_extra }}</span
              >
            </div>
            <div class="weui-form-preview__item" slot="pd_taxtotal">
              <label class="weui-form-preview__label">{{customLabel.pd_taxtotal || "不含税金额(元)"}}</label>
              <span class="weui-form-preview__value">{{
                numberFormat(item.pd_taxtotal,'#,##0.00')
              }}</span>
            </div>
            <div class="weui-form-preview__item" slot="pd_total">
              <label class="weui-form-preview__label">{{customLabel.pd_total || "含税金额(元)"}}</label>
              <span class="weui-form-preview__value">{{
                numberFormat(item.pd_total,'#,##0.00')
              }}</span>
            </div>
            <div class="weui-form-preview__item"  slot="pd_delivery">
              <label class="weui-form-preview__label">{{customLabel.pd_delivery || "需求日期"}}</label>
              <span class="weui-form-preview__value">{{
                dateFormat(item.pd_delivery,'yyyy-MM-dd')
              }}</span>
            </div>
            <div class="weui-form-preview__item" slot="pd_whname" v-if="item.pd_whname">
              <label class="weui-form-preview__label">{{customLabel.pd_whname || "仓库"}}</label>
              <span class="weui-form-preview__value">{{
                item.pd_whname
              }}</span>
            </div>
            <div class="weui-form-preview__item" slot="pd_sellername" v-if="item.pd_sellername">
              <label class="weui-form-preview__label">{{customLabel.pd_sellername || "业务员"}}</label>
              <span class="weui-form-preview__value">{{
                item.pd_sellername
              }}</span>
            </div>
            <div class="weui-form-preview__item" slot="pd_yqty" v-if="!readonly">
              <label class="weui-form-preview__label">{{
                customLabel.pd_yqty || "已转数"
              }}</label>
              <span class="weui-form-preview__value" >{{
                item.pd_yqty
              }} {{ item.productDTO.pr_unit }}</span>
            </div>
            <div  slot="pd_lastprice"
              class="weui-form-preview__item"
              v-if="item.pd_lastprice && opener != 'share'"
            >
              <label class="weui-form-preview__label">{{customLabel.pd_lastprice || "上次购价(元)"}}</label>
              <span class="weui-form-preview__value">{{
                numberFormat(item.pd_lastprice,'#,##0.####')
              }}</span>
            </div>
            <div class="weui-form-preview__item" v-if="!editable && !readonly">
              <span class="weui-form-preview__value weui-form-preview__value-icon">
                <i class="iconfont icon-change" @click="onchange(item)">变更</i>
              </span>
            </div>
          </custom-layout>
        </div>
      </collapse>

      <div class="form-preview weui-form-preview">
        <custom-layout class="weui-form-preview__bd" :view-config="customViewConfig">
          <div class="weui-form-preview__item" slot="pu_taxtotal">
            <label class="weui-form-preview__label">不含税金额(元)</label>
            <span class="weui-form-preview__value" v-format="'#,##0.00'">{{
              form.main.pu_taxtotal
            }}</span>
          </div>
          <div class="weui-form-preview__item"  slot="pu_taxamount">
            <label class="weui-form-preview__label">税额(元)</label>
            <span class="weui-form-preview__value" v-format="'#,##0.00'">{{
              form.main.pu_taxamount
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="pu_total">
            <label class="weui-form-preview__label">价税合计(元)</label>
            <span class="weui-form-preview__value" v-format="'#,##0.00'">{{
              form.main.pu_total
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="pu_remark">
            <label class="weui-form-preview__label">备注</label>
            <span class="weui-form-preview__value">{{
              form.main.pu_remark
            }}</span>
          </div>
        </custom-layout>
      </div>
      <file-list v-model="form.main.pu_attach" />
    </div>

    <div class="footer-bar weui-dialog__ft" v-if="!readonly">
      <router-link
        :to="'/purchase/order_edit?id=' + form.main.id"
        v-if="editable"
        class="weui-dialog__btn weui-dialog__btn_primary"
        >编辑</router-link
      >
      <a
        href="javascript:;"
        v-if="editable"
        class="weui-dialog__btn weui-dialog__btn_primary"
        @click="f_audit"
        >审核</a
      >
      <a
        href="javascript:;"
        v-if="editable"
        class="weui-dialog__btn weui-dialog__btn_default"
        @click="p_remove"
        >删除</a
      >
      <a
        href="javascript:;"
        v-if="!editable"
        class="weui-dialog__btn weui-dialog__btn_primary"
        @click="turnin_step_1"
        >入库</a
      >
      <a
        href="javascript:;"
        v-if="!editable"
        class="weui-dialog__btn weui-dialog__btn_default"
        @click="f_unaudit"
        >反审</a
      >
      <share
        class="weui-dialog__btn weui-dialog__btn_default"
        v-if="!editable"
        :biz-data="bizData"
      ></share>
    </div>
  </div>
</template>

<script>
import CustomLayout from "@/components/layout/CustomLayout.vue";
import FileList from "@/components/FileList.vue";
import process from "@/mixins/process.js";
import CallMobile from "@/components/button/CallMobile.vue";
import Share from "@/components/button/Share.vue";
import Collapse from "@/components/Collapse.vue";
import DownloadButton  from "@/components/button/Download.vue";
import CustomField from "@/components/field/CustomField.vue";

export default {
  mixins: [process],
  components: {
    CustomLayout,
    FileList,
    CallMobile,
    Share,
    Collapse,
    CustomField,
    DownloadButton
  },
  data() {
    return {
      baseUrl: "/api/purchase/purchase",
      codeField: "pu_code",
      statusField: "pu_statuscode",
      caller: "Purchase",
      xtype: "purchase-purchase-formpanel",
    };
  },
  computed: {
    bizData() {
      var main = this.form.main;
      if (!main) {
        return null;
      }
      return {
        bizCode: main.pu_code,
        bizType: "Purchase",
        bizId: main.id,
        viewType: "purchase-purchase-formpanel",
        title: "采购订单" + main.pu_code,
      };
    },
  },
  methods: {
    onchange(item) {
      if(item.pd_yqty >= item.pd_qty) {
        this.$weui.topTips('明细行已全部转入库，不能变更', 3000);
      } else {
        this.$router.push({
          name: 'PurchaseOrderChangeEdit',
          params: {
            itemData: item,
          },
        });
      }
    },
    /**
     * 转入库
     */
    turnin_step_1() {
      var me = this;
      me.$weui.confirm("确定转采购入库？", function () {
        me.$loading({
          url: "/api/purchase/purchase/list",
          params: {
            number: 1,
            size: 99999,
            mode: "DETAIL",
            condition: JSON.stringify([
              {
                type: "condition",
                value: "pu_code like '%" + me.form.main.pu_code + "%'",
              },
              {
                type: "condition",
                value:
                  "pu_status='已审核' and ifnull(pd_bussStatuscode,' ')<>'CLOSE' and pd_turnsendstatus!=2 and ifnull(pd_qty,0)>0",
              },
            ]),
            page: 1,
            start: 0,
            limit: 20,
          },
        })
          .then(function (res) {
            if (res.success) {
              let baseDTOs = [];
              baseDTOs = res.data.list.map((item) => {
                return {
                  code: item.pd_code,
                  id: item.pd_id,
                  qty: item.pd_qty - item.pd_yqty,
                };
              });
              me.turnin_step_2(baseDTOs);
            } else {
              me.$weui.topTips(res.message, 3000);
            }
          })
          .catch(function () {
            me.$weui.topTips("转入库失败", 3000);
          });
      });
    },
    turnin_step_2(baseDTOs) {
      let me = this;
      if (baseDTOs.length == 0) {
        me.$weui.toast("转入库成功", 2000);
        return;
      }
      me.$loading({
        url: "/api/purchase/purchase/turnPurchaseIn",
        method: "POST",
        jsonData: {
          baseDTOs,
        },
      })
        .then(function (res) {
          if (res.success) {
            me.$weui.toast("转入库成功", 2000);
            // me.$router.push("/purchase/in/" + res.data.id);
          } else {
            me.$weui.topTips(res.message, 3000);
          }
        })
        .catch(function () {
          me.$weui.topTips("转入库失败", 3000);
        });
    },
  },
};
</script>